import(/* webpackMode: "eager" */ "/codebuild/output/src2581901366/src/skop-manage/src/app/[locale]/(auth)/login/page.tsx");
